module.exports = __webpack_public_path__ + "img/CNY.5b8a68c9.svg";